import { useState } from 'react';
import { useSelector } from 'react-redux';

import { STATUS_OPEN_TO_AGENT } from '../../../../../config/portCall';

import { selectGeneralData } from '../../../slices/portCallSlice';

import SendConfirmationModal from './SendConfirmationModal';

import '../styles/instructions.scss';

export const SendFormLayout = () => {
  const generalPortcallData = useSelector(selectGeneralData);
  const { status } = generalPortcallData;
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  return (
    <>
      <SendConfirmationModal
        isConfirmationModalOpen={
          isConfirmationModalOpen || status === STATUS_OPEN_TO_AGENT
        }
        setIsConfirmationModalOpen={setIsConfirmationModalOpen}
      />
    </>
  );
};

export default SendFormLayout;
